import { Map, fromJS } from 'immutable';

import Actions from 'flow/actions';

const initialState = Map();

const customerReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE:
            return initialState;
        case Actions.RESULT_CUSTOMER: {
            return state.set(action.key, fromJS(action.data));
        }
        case Actions.RESULT_CUSTOMER_CONTACT_FIELDS: {
            return state.setIn(['contactFields'], fromJS(action.data.fields));
        }
        default:
            return state;
    }
};

export default customerReducer;
